type CartToastOptions = {
  description: string;
  icon?: string;
  timeout?: number;
}

export const useCartToast = ({ description, icon, timeout }: CartToastOptions) => {
  const toast = useToast();
  const runtimeConfig = useRuntimeConfig();
  const { isMobile } = useDevice();
  const partnerCode = runtimeConfig.public.partnerCode;
  const isOneIndiaMall = partnerCode?.toLowerCase() === 'oneindiamall' && isMobile;
  toast.add({
    id: 'cart-toast',
    icon: icon || 'i-heroicons-exclamation-triangle-solid',
    description,
    timeout: timeout || 2000,
    closeButton: { icon: '' },
    ui: {
      wrapper: isOneIndiaMall ? 'pointer-events-none animate__animated animate__fadeIn md:animate__fadeInRight animate__faster fixed top-20 left-[20px] right-[20px] w-[calc(100%-40px)]' : 'pointer-events-none animate__animated animate__fadeIn md:animate__fadeInRight animate__faster',
      container: isOneIndiaMall ? 'mb-0' : 'mb-8',
      background: 'bg-gray-800/90',
      description: 'text-white text-xs',
      rounded: 'rounded-3xl',
      padding: 'px-5 py-3',
      ring: 'ring-0',
      icon: { base: 'h-5 w-5 origin-bottom -skew-y-[24deg] self-center', color: 'text-yellow-400' },
      progress: { base: 'hidden' }
    },
  });
}